/**
 * @readonly
 * @typedef {Object} VehicleObjectDetailsModel
 * @property {string} ACCELERATION_VEHICLE_TYPE - Vehicle acceleration class (influences the classification of driving events)
 * @property {number} AXLE_WEIGHT_FRONT - The weight of the front axle of the vehicle in kg
 * @property {number} AXLE_WEIGHT_REAR - The weight of the rear axle of the vehicle in kg
 * @property {string} CAK - The Customer Activation Key
 * @property {string} CONTRACT_NUMBER - The contract number of the corresponding WEBFLEET contract
 * @property {Array<string>} CONTROL_FLAGS - A limited selection of control flags of the object
 * @property {string} CUSTOMER_NUMBER - The customer number
 * @property {string} DESCRIPTION - The description of the vehicle
 * @property {number} DIESEL_EXHAUST_FLUID_LEVEL_PERCENTAGE - The AdBlue level in percent
 * @property {boolean} DRIVER_TERMINAL_CONNECTED - Indicates if the driver terminal is connected (true) to the LINK or not (false)
 * @property {Array<string>} DRIVER_TERMINAL_MAPS -  A list of details of maps installed on the driver terminal
 * @property {string} DRIVER_TERMINAL_MODEL - The model of the driver terminal (PND)
 * @property {string} DRIVER_TERMINAL_NAV_SOFTWARE_VERSION - The version of the navigation software of the driver terminal (PND)
 * @property {string} DRIVER_TERMINAL_SERIAL_NUMBER - The serial number of the driver terminal (PND)
 * @property {string} DRIVER_TERMINAL_TTWD_SOFTWARE_VERSION - The version of the TTWD (work deamon) of the driver terminal (PND)
 * @property {number} ENGINE_TOTAL_HOURS - The total engine hours
 * @property {number} FUEL_LEVEL - The current fill level of the tank in liters
 * @property {number} FUEL_LEVEL_PERCENTAGE - The current fill level of the tank in percent
 * @property {string} FUEL_TYPE - Fuel type ['PETROL', 'DIESEL', 'HYBRID_PETROL', 'HYBRID_DIESEL', 'LPG', 'ELECTRIC', 'UNKNOWN']
 * @property {number} GROSS_WEIGHT - The gross weight of the vehicle in kg
 * @property {number} HEIGHT - The height of the vehicle in mm
 * @property {number} LENGTH - The length of the vehicle in mm
 * @property {string} LINK_APP_VERSION - The version of the LINK application
 * @property {string} LINK_DEVICE_TYPE - The device type of the LINK (for example, DRESDEN, BREMEN, etc...)
 * @property {string} LINK_OS_VERSION - The version of the LINK OS
 * @property {string} LINK_SERIAL_NUMBER - The serial number of the LINK
 * @property {number} MAX_SPEED - Max speed of the vehicle in km/h
 * @property {number} NET_WEIGHT - The net weight of the vehicle in kg
 * @property {string} OBJECT_ID - The ID of the object
 * @property {Array<Object>} OBJECT_RECURRING_CUSTOMER_BOOKINGS - List of additional contract features
 * @property {string} REFERENCE_NUMBER - The reference number
 * @property {string} REGISTRATION_DATE - The registration date of the object
 * @property {number} TANK_SIZE - Tank size in l
 * @property {number} TARIFF - The name of the tariff
 * @property {ISO8601} VALID_FROM - The date the contract started
 * @property {ISO8601} VALID_TO - The date the contract will end
 * @property {string} VEHICLE_REGISTRATION_TYPE - Vehicle registration type ['BUSINESS', 'PRIVATE']
 * @property {string} VIN - The VIN
 * @property {string} VSD_GENERATION_ID - The generation id of the vehicle
 * @property {number} WIDTH - The width of the vehicle in mm
 */
export const VehicleObjectDetailsModel = {
    ACCELERATION_VEHICLE_TYPE: 'accelerationVehicleType',
    AXLE_WEIGHT_FRONT: 'axleWeightFront',
    AXLE_WEIGHT_REAR: 'axleWeightRear',
    CAK: 'cak',
    CONTRACT_NUMBER: 'contractNumber',
    CONTROL_FLAGS: 'controlFlags',
    CUSTOMER_NUMBER: 'customerNumber',
    DESCRIPTION: 'description',
    DIESEL_EXHAUST_FLUID_LEVEL_PERCENTAGE: 'dieselExhaustFluidLevelPercentage',
    DRIVER_TERMINAL_CONNECTED: 'driverTerminalConnected',
    DRIVER_TERMINAL_MAPS: 'driverTerminalMaps',
    DRIVER_TERMINAL_MODEL: 'driverTerminalModel',
    DRIVER_TERMINAL_NAV_SOFTWARE_VERSION: 'driverTerminalNavSoftwareVersion',
    DRIVER_TERMINAL_SERIAL_NUMBER: 'driverTerminalSerialNumber',
    DRIVER_TERMINAL_TTWD_SOFTWARE_VERSION: 'driverTerminalTtwdSoftwareVersion',
    ENGINE_TOTAL_HOURS: 'engineTotalHours',
    FUEL_LEVEL: 'fuelLevel',
    FUEL_LEVEL_PERCENTAGE: 'fuelLevelPercentage',
    FUEL_TYPE: 'fuelType',
    GROSS_WEIGHT: 'grossWeight',
    HEIGHT: 'height',
    LENGTH: 'length',
    LINK_APP_VERSION: 'linkAppVersion',
    LINK_DEVICE_TYPE: 'linkDeviceType',
    LINK_OS_VERSION: 'linkOsVersion',
    LINK_SERIAL_NUMBER: 'linkSerialNumber',
    MAX_SPEED: 'maxSpeed',
    NET_WEIGHT: 'netWeight',
    OBJECT_FEATURE_QUOTAS: 'objectFeatureQuotas',
    OBJECT_ID: 'objectId',
    OBJECT_RECURRING_CUSTOMER_BOOKINGS: 'objectRecurringCustomerBookings',
    REFERENCE_NUMBER: 'referenceNumber',
    REGISTRATION_DATE: 'registrationDate',
    TANK_SIZE: 'tankSize',
    TARIFF: 'tariff',
    VALID_FROM: 'validFrom',
    VALID_TO: 'validTo',
    VEHICLE_REGISTRATION_TYPE: 'vehicleRegistrationType',
    VIN: 'vin',
    VSD_GENERATION_ID: 'vsdGenerationId',
    WIDTH: 'width'
}
